'use strict';

var lodash = require('lodash');
var getValidArrayValues = require('./getValidArrayValues/getValidArrayValues.js');
var processValues = require('./processValues/processValues.js');

/**
 * Returns all valid populated form values
 * (Field values without errors).
 */ const getValidValues = ({ getValues, getFieldState, validateSubFormFields })=>{
    const values = getValues();
    const validValues = {};
    const result = processValues.processValues({
        values,
        getFieldState,
        // Ignore sub form fields as the sub form fields will be processed below
        ignoredSubFormFields: validateSubFormFields
    });
    lodash.merge(validValues, result);
    // validate specified subform values
    if (validateSubFormFields != null) {
        // form fields to validate
        validateSubFormFields.forEach((fieldKey)=>{
            const fieldValues = getValues(fieldKey);
            if (fieldValues != null && !Array.isArray(fieldValues)) {
                throw new Error('validateSubFormFields must only include array paths.');
            }
            // if field value is a list, iterate through each field value
            const result = getValidArrayValues.getValidArrayValues({
                fieldKey,
                fieldValues,
                values,
                getFieldState
            });
            lodash.merge(validValues, result);
        });
    }
    return validValues;
};

exports.getValidValues = getValidValues;
//# sourceMappingURL=getValidValues.js.map
